// Background sync engine for the offline check-in queue (see offlineQueue.js).
// Replays each queued walk-in check-in against the real API, in order, once the
// gate tablet is back online: create the visit (this is also where the server
// finally runs the watchlist/blacklist check, retroactively for offline check-ins),
// then upload photo/ID, submit briefing signatures, and issue a badge.
import { api } from "./api";
import { dataUrlToBlob } from "./fileUtils";
import { getQueue, updateJob, removeJob } from "./offlineQueue";

async function syncJob(job) {
  updateJob(job.local_id, { status: "syncing" });
  const { data: visit } = await api.post("/visits", job.form);

  if (job.photo_base64) {
    const fd = new FormData();
    fd.append("file", dataUrlToBlob(job.photo_base64), "photo.jpg");
    await api.post(`/visits/${visit.id}/upload-photo`, fd);
  }
  if (job.id_file_base64) {
    const fd2 = new FormData();
    fd2.append("file", dataUrlToBlob(job.id_file_base64), job.id_file_name || "id-document");
    await api.post(`/visits/${visit.id}/upload-id`, fd2);
  }
  for (const sig of job.signatures || []) {
    await api.post(`/visits/${visit.id}/sign-briefing`, { briefing_id: sig.briefing_id, signature_image_base64: sig.signature_image_base64 });
  }
  await api.post(`/visits/${visit.id}/issue-badge`);

  removeJob(job.local_id);
  return visit;
}

let syncing = false;

export async function flushQueue(onResult) {
  if (syncing || !navigator.onLine) return;
  syncing = true;
  try {
    const queue = getQueue().filter((j) => j.status !== "syncing");
    for (const job of queue) {
      try {
        const visit = await syncJob(job);
        onResult?.({ ok: true, job, visit });
      } catch (err) {
        updateJob(job.local_id, { status: "pending" });
        onResult?.({ ok: false, job, error: err });
        break; // likely still offline / server unreachable - stop and retry on next cycle
      }
    }
  } finally {
    syncing = false;
  }
}

let initialized = false;

export function initOfflineSync(onResult) {
  if (initialized) return;
  initialized = true;
  window.addEventListener("online", () => flushQueue(onResult));
  setInterval(() => flushQueue(onResult), 20000);
  flushQueue(onResult);
}
